module.exports = __webpack_public_path__ + "static/media/asset42.bca13622.jpg";